import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";
import { setLoader } from "./actions";

const getStateModuleUserMedis = (state) => state.ModuleUserMedis;

export function* getMasterData() {
  try {
    yield put(setLoader(true));
    let _body = {
      MasterData: [
        {
          ObjectName: "listHakAkses",
        },
      ],
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body);
    yield all(yield put({ type: types.MODULE_USERMEDIS_MASTER_DATA_SUCCESS, property: "listHakAkses", value: response.data.listHakAkses }));
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

// onSendMail = (event) => {
//     const templateId = "template_tSRobzpE";

//     this.sendFeedback(templateId, { message_html: this.state.feedback, from_name: this.state.name, reply_to: this.state.email });
//   };

//   sendFeedback(templateId, variables) {
//     window.emailjs
//       .send("hicare", templateId, variables)
//       .then((res) => {
//         console.log("Email successfully sent!");
//       })
//       // Handle errors here however you like, or use a React error boundary
//       .catch((err) => console.error("Oh well, you failed. Here some thoughts on the error that occured:", err));
//   }

export function* postFormUserMedis(params) {
  try {
    yield put(setLoader(true));

    let stateModuleUserMedis = yield select(getStateModuleUserMedis);
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _data = stateModuleUserMedis.formUserMedis;
    const _body = {
      f_email_userm: _data.f_email_userm,
      f_nama_userm: _data.f_nama_userm,
      f_date_register: moment().format("YYYY-MM-DD HH:mm:ss"),
      f_telepon_userm: _data.f_telepon_userm,
      f_hak_akses: _data.f_hak_akses,
      f_id_klinik: _id,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_USERMEDIS_SUBMIT_USERMEDIS, _body, { headers: Header() });
    if (response.acknowledge == 1) {
      messages("Berhasil", response.message, "success", false, params.history);
    } else {
      messages("Error", response.message, "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getListUserData(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value == "all") {
      const _body = {
        id: _id,
      };
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_USERMEDIS_LIST_POST, _body);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_USERMEDIS_LISTDATA_USERMEDIS_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value) {
      // const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_OBAT_DETAIL_GET + params.value);
      // if(response.acknowledge == 1){
      //     const _data = response.data
      //     const _formDetail= {
      //         f_id_obat: _data.f_id_obat,
      //         f_nama_obat: _data.f_nama_obat,
      //         f_kode_obat: _data.f_kode_obat,
      //         f_stok_obat: _data.f_stok_obat,
      //         f_harga_obat: _data.f_harga_obat,
      //         f_nama_produsen: _data.f_nama_produsen,
      //         f_satuan_hitung: _data.f_satuan_hitung,
      //         f_status_produsen: _data.f_nama_produsen ? true : false,
      //     }
      //     yield put({ type: types.MODULE_OBAT_DATA_GET_DETAIL_SUCCESS, value: _formDetail})
      // }else{
      //     messages("Error", "Gagal memuat data", "error", false, false);
      // }
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.MODULE_USERMEDIS_MASTER_DATA, getMasterData),
    takeLatest(types.MODULE_USERMEDIS_SUBMIT_FORM_USERMEDIS, postFormUserMedis),
    takeLatest(types.MODULE_USERMEDIS_LISTDATA_USERMEDIS, getListUserData),
  ]);
}
